import {mapMutations} from 'vuex'
import {showOverlay} from "./showOverlay";

export const loaderMixin = {
  mixins: [showOverlay],
  methods: {
    ...mapMutations({
      showLoaderMethod: 'popups/SHOW_LOADER',
    }),
    showLoader() {
      this.showOverlay(true);
      this.showLoaderMethod(true);
    },
    hideLoader() {
      this.showOverlay(false);
      this.showLoaderMethod(false)
    },
    hideOnlyLoader() {
      this.showLoaderMethod(false)
    }
  }
}
